/* tslint:disable */

declare var Object: any;
export interface TtadempgetleaveInterface {
  "empgetleaveId": string;
  "empId": string;
  "leaveCode": string;
  "companyId": number;
  "startvaliddate": Date;
  "endvaliddate"?: Date;
  "nextvaliddate"?: Date;
  "entitlement"?: string;
  "proportional"?: string;
  "bringforward"?: string;
  "forfeited"?: string;
  "adjustment"?: string;
  "used"?: string;
  "remaining"?: string;
  "activeStatus": number;
  "modifiedBy": string;
  "modifiedDate": Date;
  "createdDate": Date;
  "createdBy": string;
  "currentperiod"?: Date;
  ttamleavetypes?: any;
}

export class Ttadempgetleave implements TtadempgetleaveInterface {
  "empgetleaveId": string;
  "empId": string;
  "leaveCode": string;
  "companyId": number;
  "startvaliddate": Date;
  "endvaliddate": Date;
  "nextvaliddate": Date;
  "entitlement": string;
  "proportional": string;
  "bringforward": string;
  "forfeited": string;
  "adjustment": string;
  "used": string;
  "remaining": string;
  "activeStatus": number;
  "modifiedBy": string;
  "modifiedDate": Date;
  "createdDate": Date;
  "createdBy": string;
  "currentperiod": Date;
  ttamleavetypes: any;
  constructor(data?: TtadempgetleaveInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadempgetleave`.
   */
  public static getModelName() {
    return "Ttadempgetleave";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadempgetleave for dynamic purposes.
  **/
  public static factory(data: TtadempgetleaveInterface): Ttadempgetleave{
    return new Ttadempgetleave(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadempgetleave',
      plural: 'Ttadempgetleaves',
      path: 'Ttadempgetleaves',
      properties: {
        "empgetleaveId": {
          name: 'empgetleaveId',
          type: 'string'
        },
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "leaveCode": {
          name: 'leaveCode',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "startvaliddate": {
          name: 'startvaliddate',
          type: 'Date'
        },
        "endvaliddate": {
          name: 'endvaliddate',
          type: 'Date'
        },
        "nextvaliddate": {
          name: 'nextvaliddate',
          type: 'Date'
        },
        "entitlement": {
          name: 'entitlement',
          type: 'string'
        },
        "proportional": {
          name: 'proportional',
          type: 'string'
        },
        "bringforward": {
          name: 'bringforward',
          type: 'string'
        },
        "forfeited": {
          name: 'forfeited',
          type: 'string'
        },
        "adjustment": {
          name: 'adjustment',
          type: 'string'
        },
        "used": {
          name: 'used',
          type: 'string'
        },
        "remaining": {
          name: 'remaining',
          type: 'string'
        },
        "activeStatus": {
          name: 'activeStatus',
          type: 'number'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "currentperiod": {
          name: 'currentperiod',
          type: 'Date'
        },
      },
      relations: {
        ttamleavetypes: {
          name: 'ttamleavetypes',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadempgetleave.ts